module.exports = __webpack_public_path__ + "static/media/Rewards_Center_Frame@3x.f772afcf.png";